import { Stepper } from '../../components/Stepper';

const steps = [
  {
    img: '../../assets/ios/1.png',
    description: 'Скачайте профиль для Apple iOS → нажмите «Разрешить»',
    button: { fileName: 'IOS_HARICA_TLS_RSA_Root_CA_2021.crt', label: 'Скачать профиль' },
  },
  {
    img: '../../assets/ios/h2.png',
    description:
      'Найдите загруженный профиль одним из способов:<br><br><b>Способ 1</b> (самый быстрый): «Настройки» (Settings) → в самом верху, под вашим именем (Apple ID), выберите «Профиль загружен» (Profile Downloaded)<br><br><b>Способ 2</b>: «Настройки» (Settings) → «Основные» (General) → «VPN и управление устройством» (VPN &amp; Device Management) (в старых iOS — «Профили» (Profiles) или «Управление устройством» (Device Management)) → «Загруженные профили» (Downloaded Profile) → выберите нужный профиль<br><br>В окне «Установка профиля» нажмите «Установить»',
  },
  {
    img: '../../assets/ios/h3.png',
    description:
      'Введите код-пароль для устройства → в окне «Предупреждение» нажмите «Установить» → в окне «Установка профиля» выберите «Установить» → в окне «Профиль установлен» нажмите «Готово»',
  },
  {
    img: '../../assets/ios/h2-1.png',
    description:
      'Перейдите в «Настройки» → выберите «Основные» → «Об этом устройстве» → «Доверие сертификатам» → включите доверие сертификату HARICA TLS RSA Root CA 2021, передвинув ползунок вправо',
  },
  {
    img: '../../assets/ios/h2-2.png',
    description:
      'В оповещении «Корневой сертификат» нажмите «Дальше». Процедуру включения доверия нужно провести для каждого корневого сертификата',
  },
  {
    img: '../../assets/ios/4-3.png',
    description:
      'Перейдите в раздел «Настройки» → выберите Safari → в окне «Очистить историю и данные» нажмите «Очистить» → выберите «Закрытие вкладок»',
  },
];

const IosPage = () => {
  return (
    <main>
      <h2>Установка сертификатов Harica на личные устройства iPhone и iPad</h2>
      <p>Инструкция актуальна для iOS ниже 16 версии.</p>
      <p>
        Для начала установки откройте текущую страницу в браузере Safari, после чего скачайте
        профиль конфигурации. Установите сертификаты сразу после загрузки, иначе они удалятся
        автоматически.
      </p>

      <Stepper steps={steps} />
    </main>
  );
};

export default IosPage;
